module.exports = __webpack_public_path__ + "static/media/0110_IMG_LE_SOL_LEGNI_WALNUT.bc40b6d5.webp";